import { CORE_PAYMENT_ACTION_TYPE } from "@obg/core.payment";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { IAUI_VERIFICATION_ACTION_TYPE } from "./iaui-verification.action";
import { IauiVerificationModalState, IauiVerificationState } from "./iaui-verification.model";

const initialState: IauiVerificationState = {
	modalState: IauiVerificationModalState.CLOSED,
	selectedPayment: undefined,
	dismissed: false,
	isInProgress: false,
};

export function iauiVerificationReducer(state = initialState, action: ActionWithPayload): IauiVerificationState {
	switch (action.type) {
		case IAUI_VERIFICATION_ACTION_TYPE.openModal:
			return updateState(state, {
				modalState: IauiVerificationModalState.OPEN,
				isInProgress: true,
			});
		case IAUI_VERIFICATION_ACTION_TYPE.dismissNotification:
			return updateState(state, {
				dismissed: true,
			});
		case IAUI_VERIFICATION_ACTION_TYPE.closeModal: {
			return updateState(state, {
				modalState: IauiVerificationModalState.CLOSED,
				selectedPayment: action.payload,
			});
		}
		case IAUI_VERIFICATION_ACTION_TYPE.clearPaymentType: {
			return updateState(state, {
				selectedPayment: undefined,
			});
		}
		case CORE_PAYMENT_ACTION_TYPE.close: {
			return updateState(state, {
				isInProgress: false,
			});
		}
		default:
			return state;
	}
}
